import state from './moduleReasonsState'
import actions from './moduleReasonsActions'
import getters from './moduleReasonsGetters'
import mutations from './moduleReasonsMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
